import { simplePath } from 'ze-api-contract/utils';

export const GET_EMAIL_OPTIONS = 'v2/user-profile-settings/email-options';

export function get_email_options_path(): string {
  return simplePath(GET_EMAIL_OPTIONS, {});
}
